export { default as Highlighter } from './Highlighter'



// WEBPACK FOOTER //
// ./src/core/icons/Highlighter/index.js